<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>Add Custom Price</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <pos-numeric-keyboard (onValueChange)="amount = $event"
                        (submitEvent)="onSave()"
                        [buttons]="[]"></pos-numeric-keyboard>
</ion-content>
<ion-footer>
  <ion-toolbar mode="md"
               color="light">
    <ion-buttons slot="end">
      <ion-button mode="md"
                  color="dark"
                  fill="solid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onSave()">SAVE PRICE</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
